import { NavLink } from 'react-router'
import { Icon } from '@/design-system'
import { cn } from '@/lib/cn'
import { PRIMARY_ITEMS } from './nav-config'
import styles from './MobileTabs.module.css'

export function MobileTabs() {
  return (
    <nav className={styles.tabs} aria-label="Primary">
      {PRIMARY_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={({ isActive }) => cn(styles.tab, isActive && styles.active)}
        >
          {({ isActive }) => (
            <>
              <Icon name={item.icon} size={20} filled={isActive} />
              <span>{item.label}</span>
              <span className={cn(styles.dot, !isActive && styles.dotHidden)} />
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
